import { useQuery } from 'react-query';
import type { ProductType } from 'contracts/ProductTypes';
import { api, applyQueryString } from 'services/api';

import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

export const useProductTypeOptions = () => {
  const fetchOptions = async () => {
    const url = applyQueryString('/product-types', {
      asList: true,
    });

    const { data } = await api.get<ProductType[]>(url);
    return data.map(productType => ({
      value: productType.id,
      label: productType.name,
    })).sort((a, b) => a.label.localeCompare(b.label));
  };

  const optionsQuery = useQuery({
    queryKey: ['fetch-product-type-options'],
    queryFn: fetchOptions,
    initialData: [],
    refetchOnWindowFocus: false,
  });

  return {
    singleSelectOptions: optionsQuery.data?.map(optionsMapper) || [],
    multiSelectOptions: optionsQuery.data?.map(multiSelectorOptionsMapper) || [],
    loading: optionsQuery.isLoading,
  };
};
